import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/extra-field/",

        async extraFieldsList() {
            const url = this.url();
            return await Vue.http.get(url);
        },        
        async extraFieldsListByCaptiveLogin(captiveLoginTypeId) {
            const url = this.url(captiveLoginTypeId);
            return await Vue.http.get(url);
        },
        async extraFieldsListAutomation() {
            const url = this.url(`automation/`);
            return await Vue.http.get(url);
        },
        async create({name, label, placeholder, type, options}) {
            const url = this.url();
            return await Vue.http.post(url, {
                name,
                label,
                placeholder,
                type,
                options
            });
        },
        async edit({id, establishmentId, name, label, placeholder, type, options}) {
            const url = this.url();
            return await  Vue.http.put(url, {
                id,
                establishmentId,
                name,
                label,
                placeholder,
                type,
                options
            })
        },
        async delete({extraFieldId}) {
            const url = this.url(`${extraFieldId}/`);
            return await Vue.http.delete(url);
        },
        async activate({extraFieldId, captiveLoginTypeId}) {
            const url = this.url(`${extraFieldId}/captive-login-type/${captiveLoginTypeId}`);
            return await Vue.http.post(url);
        },
        async setRequired({extraFieldId, captiveLoginTypeId}) {
            const url = this.url(`${extraFieldId}/captive-login-type/${captiveLoginTypeId}/required`);
            return await Vue.http.put(url);
        }

    },
    base
)
